
export default function AboutSection() {
  const stats = [
    { value: '20+', label: '年行业经验' },
    { value: '50+', label: '服务国家' },
    { value: '5000+', label: '合作客户' },
  ];

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              引领<strong>国际物流</strong>行业
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              <span className="font-bold">厦门中航嘉禾</span>深耕厦门自贸区二十多年来一直致力于提供全面的货运代理和物流解决方案。我们专注于空运、海运、陆运及报关清关服务，以可靠高效的运输方案连接全球各地的企业。
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              我们经验丰富的团队深谙国际贸易的复杂性，始终不懈地确保您的货物安全准时到达目的地。凭借遍布全球的合作伙伴网络和先进的货物追踪系统，我们为您提供对货物运输的全程可视化管控。
            </p>
            <div className="grid grid-cols-3 gap-6 mt-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">{stat.value}</div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/c9cee03527ca48eebdd352a3acf69ee8.jpg"
              alt="关于厦门中航嘉禾"
              className="rounded-lg shadow-xl w-full h-96 object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}